// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1ZdyB","title":"AfterBackImages_title__2KsH6","images":"AfterBackImages_images__3C2qR"};